const config = {
  contact: {
    phone: process.env.PHONE || '+212 6 60 26 87 67',
    phone2: process.env.PHONE2 || '+212 6 18 89 11 82',
    phoneFix: process.env.PHONE_FIX || '+212 5 39 95 61 58',
    email: process.env.EMAIL || 'contact@a2s-sarl.com',
    subscribeEmail: process.env.EMAIL || 'contact@a2s-sarl.com',
    whatsapp: process.env.WHATSAPP || '+212 6 60 26 87 67',
    whatsappMessage: 'Bonjour, je voudrais consulter vos services. Je viens de votre site web A2S SARL.',
    address: process.env.ADDRESS || 'A-11, ZAE FAHS ANJRA, TANGER, MAROC',
    facebook: process.env.FACEBOOK || 'https://www.facebook.com/a2ssarltanger',
    instagram: process.env.INSTAGRAM || 'https://instagram.com/a2ssarl',
    linkedin: process.env.LINKEDIN || 'https://linkedin.com/company/africa-supply-service-sarl',
  },
  map: {
    lat: parseFloat(process.env.MAP_LAT || '35.72117146892047'),
    lng: parseFloat(process.env.MAP_LNG || '-5.734554227003974'),
    googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY || '',
  },
  emailjs: {
    serviceID: process.env.EMAILJS_SERVICE_ID || '',
    templateID: process.env.EMAILJS_TEMPLATE_ID || '',
    publicKey: process.env.EMAILJS_PUBLIC_KEY || '',
  },
  shop: {
    // NOTE: CRA only injects env vars prefixed with REACT_APP_. The bare
    // process.env reads above are pre-existing and always fall back to their
    // defaults; do not copy that pattern here.
    apiBaseUrl:
      process.env.REACT_APP_SHOP_API_URL ||
      'https://a2s-sarl-dashboard.vercel.app/api/shop/v1',
    pageSize: Number(process.env.REACT_APP_SHOP_PAGE_SIZE || 24),
    homeCategoriesLimit: 8,
    maxCartLines: 50,
    maxLineQty: 999,
    searchDebounceMs: 400,
    // B2B quote mode: prices are never shown (UI or SEO metadata) and the
    // cart/checkout flow is presented as a "demande de devis". Flip to true
    // to bring back public prices.
    showPrices: false,
  },
  languages: [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ar', name: 'العربية', flag: '🇲🇦', rtl: true },
  ],
  defaultLanguage: 'fr'
};

export default config;
